import type { NavigateFunction } from 'react-router-dom';
import type { CompiledPublicTile } from '@shared/types/domainConfig';
import { routeForModule } from '@shared/lib/moduleRoutes';

/**
 * A tile that opens the Panic module — rendered as a white "SOS" on a red disc
 * (instead of icon + label) on the home grid/rail and the Estate tile grid.
 */
export function isPanicTile(tile: CompiledPublicTile): boolean {
  return (
    tile.module_required === 'panic' ||
    (tile.action_type === 'module' && tile.action_config?.module_route === '/app/panic')
  );
}

/** Run a compiled domain-config tile action (module, link, app link, flow). */
export function runTileAction(tile: CompiledPublicTile, navigate: NavigateFunction): void {
  switch (tile.action_type) {
    case 'module': {
      const route = tile.action_config.module_route ?? routeForModule(tile.module_required);
      if (route) navigate(route);
      break;
    }
    case 'link':
      if (tile.action_config.link_url) {
        window.open(tile.action_config.link_url, '_blank', 'noopener,noreferrer');
      }
      break;
    case 'app_link':
      if (tile.action_config.app_scheme) window.location.href = tile.action_config.app_scheme;
      break;
    case 'flow_template':
      if (tile.action_config.flow_template_id) {
        navigate(`/onboarding?template=${tile.action_config.flow_template_id}`);
      }
      break;
  }
}
